import store from "../store/index";
import loadSpecificCombatantExtraImage from "./loadSpecificCombatantExtraImage";
//-----------------------------
// load combatant extra images
//-----------------------------
export default function loadCombatantExtraImages() {
  // console.log("-----------------------------------");
  // console.log("IN loadCombatantExtraImages");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //----------------------
  // loop thru combatants
  //----------------------
  for (let k = 0; k < combatants.length; k++) {
    //-------------------------------------
    // load specific combatant extra image
    //-------------------------------------
    loadSpecificCombatantExtraImage(k);
  }
}
